import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconUnfoldMore.tsx
const OutlinedFilledUnfoldMore = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480-96 274-302l68-68 138 139 138-139 68 68L480-96ZM342-589l-68-67 206-206 206 206-68 67-138-138-138 138Z" })
});
const OutlinedUnfoldMore = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480-96 274-302l68-68 138 139 138-139 68 68L480-96ZM342-589l-68-67 206-206 206 206-68 67-138-138-138 138Z" })
});
const RoundedFilledUnfoldMore = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m480-231 105-105q14.57-14 33.78-14Q638-350 652-335.9q14 14.11 14 33.79T652-268L514-130q-7.17 6.91-16.33 10.95-9.16 4.05-17.91 4.05-8.76 0-17.71-4.05Q453.1-123.09 446-130L308-268q-14-14.57-14-34.28 0-19.72 14.1-34.22 14.11-13.5 33.79-13.5T376-336l104 105Zm0-496L375-622q-14.57 14-33.78 14Q322-608 308-622.1q-14-14.11-14-33.79T308-690l138-139q7.16-6 16.31-10.5 9.16-4.5 17.9-4.5 8.75 0 17.77 4.5T514-829l138 139q14 14.57 14 34.28 0 19.72-14.1 34.22-14.11 13.5-34 13Q598-609 584-623L480-727Z" })
});
const RoundedUnfoldMore = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m480-231 105-105q14.57-14 33.78-14Q638-350 652-335.9q14 14.11 14 33.79T652-268L514-130q-7.17 6.91-16.33 10.95-9.16 4.05-17.91 4.05-8.76 0-17.71-4.05Q453.1-123.09 446-130L308-268q-14-14.57-14-34.28 0-19.72 14.1-34.22 14.11-13.5 33.79-13.5T376-336l104 105Zm0-496L375-622q-14.57 14-33.78 14Q322-608 308-622.1q-14-14.11-14-33.79T308-690l138-139q7.16-6 16.31-10.5 9.16-4.5 17.9-4.5 8.75 0 17.77 4.5T514-829l138 139q14 14.57 14 34.28 0 19.72-14.1 34.22-14.11 13.5-34 13Q598-609 584-623L480-727Z" })
});
const SharpFilledUnfoldMore = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480-96 274-302l68-68 138 139 138-139 68 68L480-96ZM342-589l-68-67 206-206 206 206-68 67-138-138-138 138Z" })
});
const SharpUnfoldMore = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480-96 274-302l68-68 138 139 138-139 68 68L480-96ZM342-589l-68-67 206-206 206 206-68 67-138-138-138 138Z" })
});
const componentMap = {
	outlined: OutlinedUnfoldMore,
	"outlined-fill": OutlinedFilledUnfoldMore,
	rounded: RoundedUnfoldMore,
	"rounded-fill": RoundedFilledUnfoldMore,
	sharp: SharpUnfoldMore,
	"sharp-fill": SharpFilledUnfoldMore
};
const IconUnfoldMore = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconUnfoldMore };